"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnterpriseReportingReport_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var EnterpriseReportingColumnDefinition_1 = require("./EnterpriseReportingColumnDefinition");
var EnterpriseReportingProcessedRows_1 = require("./EnterpriseReportingProcessedRows");
var EnterpriseReportingReport_Factory = /** @class */ (function () {
    function EnterpriseReportingReport_Factory() {
    }
    EnterpriseReportingReport_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CanFilterByDate: model.CanFilterByDate,
            CanFilterByDepartmentCode: model.CanFilterByDepartmentCode,
            CanFilterByEnterpriseLocationId: model.CanFilterByEnterpriseLocationId,
            CanFilterByUserId: model.CanFilterByUserId,
            ColumnDefinitions: model.ColumnDefinitions && model.ColumnDefinitions.map(function (i) { return EnterpriseReportingColumnDefinition_1.EnterpriseReportingColumnDefinition_Factory.CreateIncoming(i); }),
            DatabaseType: model.DatabaseType,
            Description: model.Description,
            Name: model.Name,
            ProcessedRows: model.ProcessedRows && model.ProcessedRows.map(function (i) { return EnterpriseReportingProcessedRows_1.EnterpriseReportingProcessedRows_Factory.CreateIncoming(i); }),
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            StoredProcedure: model.StoredProcedure,
            SystemReport: model.SystemReport,
        };
        return result;
    };
    EnterpriseReportingReport_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CanFilterByDate: model.CanFilterByDate,
            CanFilterByDepartmentCode: model.CanFilterByDepartmentCode,
            CanFilterByEnterpriseLocationId: model.CanFilterByEnterpriseLocationId,
            CanFilterByUserId: model.CanFilterByUserId,
            ColumnDefinitions: model.ColumnDefinitions && model.ColumnDefinitions.map(function (i) { return EnterpriseReportingColumnDefinition_1.EnterpriseReportingColumnDefinition_Factory.CreateOutgoing(i); }),
            DatabaseType: model.DatabaseType,
            Description: model.Description,
            Name: model.Name,
            ProcessedRows: model.ProcessedRows && model.ProcessedRows.map(function (i) { return EnterpriseReportingProcessedRows_1.EnterpriseReportingProcessedRows_Factory.CreateOutgoing(i); }),
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            StoredProcedure: model.StoredProcedure,
            SystemReport: model.SystemReport,
        };
        return result;
    };
    return EnterpriseReportingReport_Factory;
}());
exports.EnterpriseReportingReport_Factory = EnterpriseReportingReport_Factory;
